import { ReactComponent as CheckmarkIcon } from "../../assets/icons/checkmark.svg";
import { COOKIE_TYPES } from "../../enums/cookies";
import useBreakpoints, { Breakpoint } from "../../hooks/useBreakpoints";

interface CookieCardProps {
    type: any;
    title: string;
    description: string;
    index: number;
    total: number;
    isActive?: boolean;
    onClick: () => void;
}

export const CookieCard = (props: CookieCardProps) => {
    const isRequiredCookie = props.type === COOKIE_TYPES.REQUIRED;

    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    let mdClasses = "rounded-none";

    if (props.index === 0) {
        mdClasses = "rounded-tl-4xl rounded-bl-4xl";
    } else if (props.index === props.total - 1) {
        mdClasses = "rounded-tr-4xl rounded-br-4xl";
    }

    const cornerClasses = getStyleBasedOnBreakpoint(Breakpoint.MD, mdClasses, "rounded-md");

    const baseClasses =
        "cookieCard flex flex-col items-center p-xs text-center shadow-inner gap-xs transition-all duration-200";

    const requiredCookieClasses = "bg-happy-apple-300 text-happy-apple-900 cursor-default translate-y-[-2px]";

    const activeCookieClasses = "cursor-pointer bg-happy-apple-200 text-happy-apple-900 translate-y-[-2px]";

    const inactiveCookieClasses = "cursor-pointer bg-stone-200 text-stone-900 hover:translate-y-[-2px]";

    const conditionalClasses = isRequiredCookie
        ? requiredCookieClasses
        : props.isActive
        ? activeCookieClasses
        : inactiveCookieClasses;

    const cardClasses = `${baseClasses} ${cornerClasses} ${conditionalClasses}`;

    return (
        <button
            className={cardClasses}
            disabled={isRequiredCookie}
            data-cookie-type={props.type}
            onClick={props.onClick}
        >
            <CheckmarkIcon
                className={`h-8 w-8 rounded-circle ${
                    isRequiredCookie || props.isActive ? "border-2" : "border-0 text-stone-500"
                }`}
                fill="currentColor"
            />
            <h3 className="text-l font-medium">{props.title}</h3>
            <p className="text-xs font-medium">{props.description}</p>
        </button>
    );
};
